import { __cFocCampaignService } from '@/services/client/__c.foc-campaign.service'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useSaveFocProfileMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['mutation.save-foc-profile'],
    mutationFn: __cFocCampaignService.saveKolProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['foc-profile-me'] })
    },
  })
}
